module.exports = __webpack_public_path__ + "static/media/dci2.4bb3828b.webp";